"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _context = require("../../context");

var _styles = require("../../styles");

var _utils = require("../../utils");

var _excluded = ["disabled", "error", "theme", "warning"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DateTimeInputContainer = (0, _context.styledWithTheme)('div')(function (_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      theme = _ref.theme,
      warning = _ref.warning,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var selectors = theme.selectors;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _styles.inputStyles)({
    error: error,
    selectors: selectors,
    warning: warning,
    props: props
  })), (0, _styles.disabledStyles)({
    error: error,
    disabled: disabled,
    selectors: selectors,
    warning: warning
  })), (0, _utils.getPropsStyles)(['display', 'flex', 'alignSelf'], props)), (0, _utils.getSpacingStyles)(['width', 'minWidth', 'maxWidth', 'margin', 'padding'], props, selectors.space)), (0, _styles.disabledIconStyles)({
    disabled: disabled,
    theme: theme
  })), {}, {
    display: 'flex',
    userSelect: 'none',
    position: 'relative',
    alignItems: 'center'
  });
});
var _default = DateTimeInputContainer;
exports.default = _default;